import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getBrandLogo } from '@/lib/brandLogos';

interface HomeBrandChipProps {
  brand: string;
  count: number;
  accentColor: string;
  compact?: boolean;
  light?: boolean;
  logoOnly?: boolean;
}

export function HomeBrandChip({ brand, count, accentColor, compact, light, logoOnly }: HomeBrandChipProps) {
  const [logoFailed, setLogoFailed] = useState(false);
  const logo = getBrandLogo(brand);
  const showLogo = Boolean(logo) && !logoFailed;

  return (
    <Link
      to={`/estoque?brand=${encodeURIComponent(brand)}`}
      className={[
        'wl5-av-brand-chip',
        compact && 'wl5-av-brand-chip--compact',
        light && 'wl5-av-brand-chip--light',
        logoOnly && 'wl5-av-brand-chip--logo',
      ]
        .filter(Boolean)
        .join(' ')}
      title={`${brand} — ${count} veículo${count !== 1 ? 's' : ''}`}
    >
      <span className="wl5-av-brand-chip-icon" aria-hidden="true">
        {showLogo ? (
          <img src={logo} alt="" onError={() => setLogoFailed(true)} />
        ) : (
          <span className="wl5-av-brand-chip-initial" style={{ color: accentColor }}>
            {brand.charAt(0).toUpperCase()}
          </span>
        )}
      </span>
      {!logoOnly && (
        <span className="wl5-av-brand-chip-text">
          <span className="wl5-av-brand-chip-name">{brand}</span>
          {!compact && (
            <span className="wl5-av-brand-chip-count">
              {count} {count === 1 ? 'veículo' : 'veículos'}
            </span>
          )}
        </span>
      )}
    </Link>
  );
}
